import script from "./index.vue?vue&type=script&lang=jsx"
export * from "./index.vue?vue&type=script&lang=jsx"

import "./index.vue?vue&type=style&index=0&id=1ed0232e&lang=scss"

const __exports__ = script;

export default __exports__